import { h } from 'preact';
import Store from 'store/store';
import * as BaseComp from 'components/bolt/movieDetails/movieDetails.js';
// import s from 'components/bolt/movieDetails/movieDetails.sss';
import * as actions from 'store/actions';

export default class MovieDetails extends BaseComp.default {

	onModelLoadStarted() {
		Store.emit(actions.TRACK_MODEL_VIEWER_LOAD_START);
	}

	onModelLoading(val) {
		Store.emit(actions.TRACK_MODEL_VIEWER_PROGRESS, val);
	}

	onModelLoadedCompleted() {
		Store.emit(actions.TRACK_MODEL_VIEWER_LOADED);
	}
}